export default "__VITE_ASSET__HidbSljxtkqxvW91gyTGhg__"